/**
 * MSAL/B2C config removed — AgentPortal authenticates via internal SSO
 * (src/auth/sso.js). This file is retained only so the ~37 `src/api/*.js` modules that
 * still import `ExtHubRequest` / `APRequest` / `loginRequest` keep resolving; those
 * `scopes` arguments are now INERT NO-OPS. A single Stytch session token (aud = ProjectId)
 * serves every resource server, so the API adapters ignore the scope value entirely and
 * only use its presence to distinguish an authenticated call from an anonymous one
 * (see api2.js/api3.js). Strip the scope args + this file in a later cleanup.
 */

// Truthy placeholders — presence (not value) is what api2/api3 read to decide "authenticated".
export const ExtHubRequest = { scopes: [] };
export const APRequest = { scopes: [] };
export const loginRequest = { scopes: [] };
export const graphRequest = { scopes: [] };
